import React from "react";
import "./App.css"; // Create a CSS file for loader styling

const Loader = () => (
  <div className="loader-overlay">
    <div className="loader"></div>
    <p className="loader-text">Please wait until the payment page opens..</p>
  </div>
);

export default Loader;
